import { useState } from "react";
import TabSection from "../../components/common/TabSection";
import LTAnalyticsRunOverviewPBI from "./LTAnalyticsRunOverviewPBI";
import LTPerformanceOptimizedPBI from "./LTPerformanceOptimizedPBI";

const LTPerformanceMetricsPBI = () => {
    const [subTabValue, setSubTabValue] = useState(0);
    const handleChangeSubTabValue = (event, newValue) => {
        setSubTabValue(newValue);
    };

    return (
        <div className="main-container paramaeter-tab-container" >
            <div className="tab-part-kpi" >
                <TabSection
                    style={{ maxWidth: "650px", marginBottom: "30px", width: "100%" }}
                    label={["Lead Time Analytics Run Overview", "Top 5 Updates"]}
                    value={subTabValue}
                    handleChange={handleChangeSubTabValue}
                />
                {subTabValue === 0 ? <LTAnalyticsRunOverviewPBI /> : <LTPerformanceOptimizedPBI />}
            </div>
        </div>
    )
}

export default LTPerformanceMetricsPBI;